<template>
  <div class="preview-section" id="position">
    <div class="preview-header">
      <h3 class="title">素材预览列表</h3>
      <span class="count">共 {{ tableData.length }} 个素材</span>
    </div>

    <el-table :data="tableData" class="table" v-loading="loading">
      <el-table-column type="index" width="50"></el-table-column>
      <el-table-column label="素材信息" min-width="300">
        <template slot-scope="scope">
          <div class="material-info">
            <el-image
              v-if="scope.row.img"
              class="material-thumb"
              :src="scope.row.img"
              :preview-src-list="[scope.row.img]"
              fit="cover"
            >
              <div slot="error" class="image-error">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
            <div class="material-detail">
              <p class="code">{{ scope.row.id }}</p>
              <p class="label" v-if="scope.row.imgType">{{ scope.row.imgType }}</p>
              <p class="size" v-if="scope.row.imgSize">{{ scope.row.imgSize }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="下载费用" width="150">
        <template slot-scope="scope">
          <div class="price" v-if="scope.row.type && scope.row.isFree">
            <p class="font-green">免费</p>
          </div>
          <div class="price" v-else-if="scope.row.type">
            <p class="font-blue">
              单价：{{ scope.row.price }} 元
              <span v-if="scope.row.orgPrice"><del>(原价：{{ scope.row.orgPrice }} 元)</del></span>
            </p>
          </div>
          <div class="price" v-else>
            <p class="font-red">{{ scope.row.msg }}</p>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="150">
        <template slot-scope="scope">
          <div v-if="scope.row.loading" class="process-bar"></div>
          <div v-else-if="scope.row.complete && scope.row.isFree">
            <el-tag type="success" size="small">已完成</el-tag>
          </div>
          <div v-else-if="scope.row.isFree">
            <el-tag type="warning" size="small">获取中</el-tag>
          </div>
          <el-tag v-else-if="scope.row.type" type="success" size="small">可下载</el-tag>
          <el-tag v-else type="danger" size="small">获取失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template slot-scope="scope">
          <div v-if="scope.row.complete && scope.row.downurl">
            <a :href="scope.row.downurl" target="_blank" rel="nofollow">
              <el-button type="primary" size="small" icon="el-icon-download">下载</el-button>
            </a>
            <a v-if="scope.row.downurl2" :href="scope.row.downurl2" target="_blank" rel="nofollow" style="margin-left: 5px;">
              <el-button type="success" size="small">备用</el-button>
            </a>
          </div>
          <el-button v-else-if="!scope.row.loading" type="text" size="small" @click="deleteRow(scope.$index)">
            <i class="el-icon-delete"></i> 删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="preview-footer" v-if="tableData.length > 0">
      <div class="total-info">
        <span>总计：<strong>{{ tableData.length }}</strong> 个素材</span>
        <span v-if="freeItemCount > 0">免费：<strong class="free-count">{{ freeItemCount }}</strong> 个</span>
        <span>预计费用：<strong class="total-price">{{ totalPrice }}</strong> 元</span>
      </div>
      <div class="action-buttons">
        <el-button @click="clearAll" plain>清空列表</el-button>
        <el-button
          type="primary"
          icon="el-icon-upload2"
          @click="submitWorkOrder"
          :disabled="!hasValidItems"
          :loading="submitting"
        >
          提交工单
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    submitting: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableData() {
      return this.data;
    },
    freeItemCount() {
      // 计算免费素材数量
      return this.tableData.filter(item => item.isFree).length;
    },
    totalPrice() {
      // 只计算需要付费的素材（非免费）
      return this.tableData
        .filter(item => item.type && !item.isFree)
        .reduce((sum, item) => sum + (parseFloat(item.price) || 0), 0)
        .toFixed(2);
    },
    hasValidItems() {
      // 只检查需要付费的素材（非免费）
      return this.tableData.some(item => item.type && !item.isFree);
    },
  },
  methods: {
    deleteRow(index) {
      this.$emit('delete', index);
    },
    clearAll() {
      this.$emit('clear');
    },
    submitWorkOrder() {
      // 只提交需要付费的素材（非免费）
      const validIds = this.tableData
        .filter(item => item.type && !item.isFree)
        .map(item => item.id);
      this.$emit('submit', validIds);
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.preview-section {
  margin-top: 30px;
  background: white;
  padding: 30px;
  border-radius: 4px;

  .preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;

    .title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      margin: 0;
    }

    .count {
      font-size: 14px;
      color: #666;
    }
  }

  .table {
    ::v-deep .el-table__header-wrapper {
      th {
        background-color: #f5f7fa;
        color: #333;
        font-weight: 600;
      }
    }

    .material-info {
      display: flex;
      align-items: center;

      .material-thumb {
        width: 60px;
        height: 60px;
        border-radius: 4px;
        margin-right: 12px;
        flex-shrink: 0;

        ::v-deep img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .image-error {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #f5f7fa;
        color: #909399;
        font-size: 20px;
      }

      .material-detail {
        flex: 1;

        .code {
          margin: 0 0 5px 0;
          font-size: 14px;
          color: #0773fc;
          font-weight: 500;
        }

        .label {
          margin: 0;
          font-size: 13px;
          color: #666;
        }

        .size {
          margin: 0;
          font-size: 12px;
          color: #999;
        }
      }
    }

    .price {
      .font-blue {
        color: #0773fc;
      }

      .font-green {
        color: #67c23a;
        font-weight: 600;
      }

      .font-red {
        color: #f56c6c;
      }

      del {
        color: #999;
        font-size: 12px;
      }
    }

    .process-bar {
      width: 80px;
      height: 6px;
      border: 1px solid #0773fc;
      border-radius: 3px;
      animation: progress-bar-stripes 1s linear infinite;
      background-color: #0773fc;
      background-image: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.15) 25%,
        transparent 25%,
        transparent 50%,
        rgba(255, 255, 255, 0.15) 50%,
        rgba(255, 255, 255, 0.15) 75%,
        transparent 75%,
        transparent
      );
      background-size: 20px 20px;
    }

    @keyframes progress-bar-stripes {
      from {
        background-position: 40px 0;
      }
      to {
        background-position: 0 0;
      }
    }
  }

  .preview-footer {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #ebeef5;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .total-info {
      font-size: 14px;
      color: #666;

      span {
        margin-right: 30px;
      }

      strong {
        color: #333;
        font-size: 16px;
      }

      .total-price {
        color: #f56c6c;
        font-size: 18px;
        font-weight: bold;
      }

      .free-count {
        color: #67c23a;
        font-size: 16px;
        font-weight: bold;
      }
    }

    .action-buttons {
      display: flex;
      gap: 15px;

      .el-button {
        padding: 12px 30px;
        font-size: 14px;
      }
    }
  }
}
</style>
